export const controlCentreQueryKeys = {
  all: ['control-centre'] as const,
};
